import React from 'react';
import Header from '../shared/header/Header';
import LeftSidebar from '../shared/sidebar/Sidebar';

const MasterPrivateLayout = ({ children }) => {
	return (
		<>
			<Header />
			<LeftSidebar />
			<div className="content-page">
				<div className="content">
					<div className="container-fluid">
						{children}
					</div>
				</div>
			</div>
		</>
	)
}

export default MasterPrivateLayout;